import { render, staticRenderFns } from "./colorful-paragraph.vue?vue&type=template&id=641be136&"
import script from "./colorful-paragraph.vue?vue&type=script&lang=ts&"
export * from "./colorful-paragraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports